<template>
    <span> 
        <b-form-select style="width: 100%"
                       size="sm"
                       v-bind:style="{color: $store.state.siteData.legColors[index], border: '1px solid gray'}"
                       v-model="month" :options="options"></b-form-select>

    </span>
</template>

<script>
    import {contractNameDecomposer, ConstrainSampleContract} from "../js/main";
    import {getCommoditiesObject} from '../js/main';

    export default {
        props: ['namespace', 'index'],
        computed: {
            commoditiesObject() {
                return getCommoditiesObject();
            },
            month: {
                get() {
                    return this.$store.getters[this.namespace + "/m"][this.index];
                },
                set(month) {
                    let oldMonth = this.month;
                    if (month !== oldMonth) {
                        let year = contractNameDecomposer(this.$store.state[this.namespace].sampleContract[0]).year;
                        console.log("month =", month);
                        let commodity = contractNameDecomposer(this.$store.state[this.namespace].sampleContract[this.index]).commoditySymbol;
                        let newSampleContractArray = this.$store.state[this.namespace].sampleContract.slice(0);
                        let newContract = commodity + year + month;
                        console.log("newContract =", newContract);

                        newSampleContractArray[this.index] = newContract;

                        newSampleContractArray = ConstrainSampleContract(newSampleContractArray);
                        this.$store.commit(this.namespace + '/setSampleContract', newSampleContractArray);
                        this.$store.commit(this.namespace + '/setSelected', []);
                        this.$store.dispatch(this.namespace + '/getContractListsFromServer');
                    }
                }
            },
            options() {
                let commodity = this.$store.getters[this.namespace + "/c"][this.index];
                let monthObjects = Object.values(this.commoditiesObject[commodity].months);

                return monthObjects.map(x => {
                    return {value: x.symbol, text: x.name};
                });
            },
            monthObjects: function () {
                // console.log("monthObjects() starting.");
                let commodity = this.$store.getters[this.namespace + "/c"][this.index];
                let commodityObject = this.commoditiesObject[commodity];
                return commodityObject.months;
            }
        }
    }
</script>
